import type { DomainAccess } from 'reactApp/components/SharingWindow/Sharing.types';
import type { WeblinkDownloadsCounts } from 'reactApp/modules/public/public.types';
import type { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';

export type Kind =
    | 'folder'
    | 'invites'
    | 'storage'
    | 'camera-upload'
    | 'shared'
    | 'mounted'
    | 'domain-folder'
    | 'file'
    | 'video'
    | 'audio'
    | 'image'
    | 'source'
    | 'document'
    | 'light-markup'
    | 'text'
    | 'pdf,document'
    | 'album'
    | 'family';

export type SubKind =
    | 'video'
    | 'archive'
    | 'picture'
    | 'audio'
    | 'android-package'
    | 'source'
    | 'playlist'
    | 'exec'
    | 'ebook'
    | 'html'
    | 'email'
    | 'plain-text'
    | 'spreadsheet'
    | 'debian-package'
    | 'text'
    | 'calendar'
    | 'json'
    | 'presentation'
    | 'card'
    | 'markdown'
    | 'chart'
    | 'graphics'
    | 'pdf'
    | 'photoshop'
    | 'web-feed'
    | 'flash'
    | 'torrent'
    | 'light-markup'
    | 'unknown';

export type VirusScan = 'pass' | 'fail' | 'not_yet' | 'skip';

export enum AccessRights {
    read = 'r',
    write = 'rw',
    comment = 'comment',
}

export interface Sort {
    type: ESortTypes | null;
    order?: ESortOder;
}

export interface Count {
    folders: number;
    files: number;
    all: number; // вычисляемое
    loaded: number; // вычисляемое
}

export interface Weblink extends WeblinkDownloadsCounts {
    id: string;
    flags?: IFlags;
    expires?: number;
    ctime?: number;
    name: string;
    intra_domain_share?: boolean;
    download_limit?: any;
}

export interface IFlags {
    DOMESTIC?: boolean;
    WRITABLE?: boolean;
    AUTODELETE?: boolean;
    DOWNLOADABLE?: boolean;
    SEO_INDEXED?: boolean;
    COMMENTABLE?: boolean;
}

export interface IFileFlags {
    favorite?: boolean;
    blocked?: boolean;
    restricted?: boolean;
    depo?: boolean;
    SEO_INDEXED?: boolean;
}

export interface Url {
    get: string;
    view: string;
    download?: string;
    downloadAPI?: string;
    media?: string;
    viewDirect?: string;
}

export interface IPublicInfo extends WeblinkDownloadsCounts {
    weblink: string;
    weblinkAccessRights: AccessRights;
    weblinkExpires: number;
    weblinkDomestic: boolean;
    weblinkDomainAccess: DomainAccess;
    weblinkAutoDelete: boolean;
    weblinkDownloadable: boolean;
    weblinkSeoEnabled?: boolean;
    weblinkEnabledDisabledDownload?: boolean;
    ctime: number;
    uniqueId?: string;
}

export interface IThumbsBase {
    xms0: string;
    xms4: string;
    xm0: string;
}

export const mapKindToName: Partial<Record<Kind, string>> = {
    album: 'Альбом',
    audio: 'Аудио',
    document: 'Документ',
    image: 'Изображение',
    'pdf,document': 'Файл PDF',
    video: 'Видео',
} as const;

export const mapSubKindToName: Partial<Record<SubKind, string>> = {
    archive: 'Архив',
    ebook: 'Электронная книга',
    presentation: 'Презентация',
    spreadsheet: 'Таблица',
} as const;
